import { Base } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'

export default function ReferralStatusPill({ status }: { status: string }) {
  const { t } = useTranslation()

  switch (status) {
    case 'APPROVED':
      return (
        <Base.Badge tone="success" dot>
          {t('referrals.table.status.approved')}
        </Base.Badge>
      )
    case 'DECLINED':
      return (
        <Base.Badge tone="danger" dot>
          {t('referrals.table.status.declined')}
        </Base.Badge>
      )
    default:
      return <Base.Badge dot>{t('referrals.table.status.pending')}</Base.Badge>
  }
}
